import { css } from '@emotion/react';

const ImageStyles = css`
    display: block;
    width: 200px;
    height: auto;
`;

export default ImageStyles;
